// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import store from './store'
import server from './utils/server'
import exportServer from './utils/exportServer'
import './permission' // 权限
import * as filters from './filters' // 全局filter
import my from './public/common'
import _ from 'lodash';


Vue.use(ElementUI)
Vue.prototype.server = server;
Vue.prototype.exportServer = exportServer;
Vue.prototype.lodash = _
// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

// register global vue methods
Vue.prototype.my = my;

Vue.config.productionTip = false;


let gbaseURL = '/api';
let gimgUrl = '';
let ossUrl='https://minica.oss-cn-shanghai.aliyuncs.com/';

if(location.hostname == 'localhost'){

  gbaseURL= 'https://localhost:44378/api';
  gimgUrl = 'https://localhost:44378/';
}
// else{
//   gbaseURL= 'https://ztj.minica.cn/api';
//   gimgUrl = 'https://ztj.minica.cn/';
// }
Vue.prototype.gbaseURL = gbaseURL;
Vue.prototype.gimgUrl = gimgUrl;
Vue.prototype.ossUrl=ossUrl;


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js